<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4 "></div>
                

                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Announcement</div>
                
                </div>
              
                  
                        <div class="rounded w-100 mt-2 p-5 mb-5  text-white bodyTextStyle"  [style.background-color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.secondaryColor ||'#01a5e0'" [innerHTML]="sanitizer.bypassSecurityTrustHtml((dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.announcement?.text)">
                    
                       </div>
                       
                

                   
              
            </div>

            <div class="container m-auto text-center">
                            <a><button
                        class="btn btn-primary  btn-continue m-auto" (click)="back()">Continue</button></a></div>
        </div>
    </div>
</div>